import { clearCache } from '@growthbook/growthbook';
import { clearWebStorage } from '@/lib/storage/browserStorage';
import {
  GROWTHBOOK_DEVICE_ID_KEY,
  GROWTHBOOK_FEATURES_CACHE_KEY,
  GROWTHBOOK_STICKY_BUCKET_PREFIX,
} from './constants';

let cleanupGeneration = 0;

export const markGrowthBookCleanupStale = (): void => {
  cleanupGeneration += 1;
};

/**
 * Clears GrowthBook client persistence when consent is withdrawn: sticky experiment assignments, the SDK feature-definition cache (`gbFeaturesCache`), and in-memory cache.
 */
const removeGrowthBookLocalStorageKeys = (): void => {
  clearWebStorage(
    () => window.localStorage,
    (key) =>
      key.startsWith(GROWTHBOOK_STICKY_BUCKET_PREFIX) ||
      key === GROWTHBOOK_FEATURES_CACHE_KEY ||
      key === GROWTHBOOK_DEVICE_ID_KEY
  );
};
export const clearGrowthBookClientStorage = (): void => {
  cleanupGeneration += 1;
  const generation = cleanupGeneration;

  try {
    removeGrowthBookLocalStorageKeys();
  } catch {
    // Storage may be unavailable in restricted browser contexts.
  }

  clearCache()
    .catch(() => {
      // SDK cache clear is best-effort; localStorage keys are already removed.
    })
    .finally(() => {
      if (generation !== cleanupGeneration) {
        return;
      }
      try {
        removeGrowthBookLocalStorageKeys();
      } catch {
        // clearCache may rewrite gbFeaturesCache; remove it if storage is available.
      }
    });
};
